import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {ApiResponseModel, ApiVisa} from '../shared';
import {CountryCityPostalCodeContainerModel} from '../../../../../models/aggregates/country/bl_fi_country_city_postal_code_container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';


@Injectable({
  providedIn: 'root'
})
export class CountryCityPostalCodeService extends BaseApiPublicLoginTemplateService<CountryCityPostalCodeContainerModel,CountryCityPostalCodeContainerModel,CountryCityPostalCodeContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'city-postal-codes/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'city-postal-codes/backoffice-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'city-postal-codes/backoffice-ep';
    this.endpoint_path_login_url = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'city-postal-codes/' + BaseApiTemplateService.LOGIN_EP;
    this.httpClient = http;
  }
}
